import { gql } from '@apollo/client';

export const FILTERED_SP_DASHBOARD_LAYOUTS = gql`
  query FilteredSPDashboardLayouts($input: DashboardLayoutFilterArgs!) {
    layouts: filteredServiceProviderDashboardLayouts(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          createdAt
          updatedAt
          name
          category
          isDefault
          assignedTo {
            id
            firstName
            lastName
          }
        }
      }
    }
  }
`;
